// focusTopMixin.js
export default {
  watch: {
    '$route'() {
      this.focusTop();
    }
  },
  methods: {
    focusTop() {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });

      const mainContent = document.querySelector('main') || document.body;
      if (mainContent) {
        mainContent.setAttribute('tabindex', '-1');
        mainContent.focus();
        mainContent.removeAttribute('tabindex');
      }
    }
  }
};
